import BaseLevelScene from './BaseLevelScene';
import { SceneConfig } from './SceneConfig';

export default class CustomScene extends BaseLevelScene {
  tileWidth: integer;
  tileHeight: integer;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  images: Array<{name: string, path: string}>;
  cameraZoom: number;
  constructor(config: SceneConfig) {
    super(config.name);
    this.name = config.name;
    this.tileMapName = config.tileMapName;
    this.tileMapPath = config.tileMapPath;
    this.images = config.images;
    this.playerScale = config.playerScale;
    this.cameraZoom = config.cameraZoom;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG files
    this.images.forEach(image => {
      this.load.image(image.name, image.path);
    });

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath
    );

}

  create() {
    // create the Tilemap
    console.log(this.tileMapName);
    this.map = this.make.tilemap({ key: this.tileMapName });



    // add all tileset image we are using (note name must match tileset in map)
    const tilesetNames = this.map.tilesets.map(ts => ts.name);
    const tilesets = tilesetNames.map(name => this.map.addTilesetImage(name, name));


    // // create the layers we want in the right order
    const base = this.map.createLayer('Base', tilesets);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(base);

    const textures = this.map.createLayer('Textures', tilesets);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', tilesets);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const decorations = this.map.createLayer('Decorations', tilesets);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);

    // create base level
    this.createBaseLevel(this.playerScale, this.cameraZoom);
  }
}
